import React from "react";
import dnagif from "../static/images/dnagif.gif"


export const OlatcgNodata = () => {

    
  return (
    
    <div>
      <center><img src = {dnagif} alt = "dna gif" class = "center" display = "block" margin-left = "50px"
  margin-right = "auto"
  width = "50%" ></img></center>
    </div>
  );
  };
export default OlatcgNodata;
